module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "list-item click",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'overDateDetail',
            query: {
              shopId: item.shopId,
              selectType: 1
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "flex-center"
    }, [_c('div', {
      staticClass: "flex1 fs-32 color-333 flex-center"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("RFID柜")]), _vm._v(_vm._s(item.shopName) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "fs-32 color-warning ml-20"
    }, [_vm._v("待处理")])]), _vm._v(" "), _c('div', {
      staticClass: "flex fs-28 mt-10"
    }, [_c('div', {
      staticClass: "color-999"
    }, [_vm._v("数量："), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.rfidCount))])]), _vm._v(" "), _c('div', {
      staticClass: "color-999",
      staticStyle: {
        "margin-left": ".5rem"
      }
    }, [_vm._v("种类："), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.typeCount))])])])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba3d0c68","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/warning/overDateList.vue
// module id = hqbd
// module chunks = 51